<template>
  <div class="search-layout">
    <div class="search-header" v-if="header || $slots.header">
      <template v-if="header">
        <div class="search-header-title">欢迎使用</div>
        <div class="search-header-subtitle">国泰车险{{ header }}</div>
      </template>
      <template v-if="$slots.header">
        <slot name="header"></slot>
      </template>
    </div>
    <div class="search-content">
      <slot></slot>
    </div>
    <div class="search-footer">
      <page-footer :showHotline="showHotline" />
    </div>
  </div>
</template>

<script>
import PageFooter from '@/components/PageFooter';

export default {
  name: 'SearchLayout',

  components: {
    PageFooter,
  },

  props: ['header', 'showHotline'],
};
</script>

<style lang="less">
.search-layout {
  display: flex;
  min-height: 100%;
  flex-direction: column;
  background-color: #fff;

  .search-header {
    padding: 50px 16px;
    font-size: 24px;
    color: #ffffff;
    background-image: linear-gradient(
      135deg,
      #3a91ec 0%,
      #426ed9 67%,
      #426ed9 100%
    );
  }

  .search-header-subtitle {
    margin-top: 10px;
    font-size: 20px;
  }

  .search-content {
    padding-top: 32px;
    margin-top: -16px;
    box-shadow: 0px -30px 15px -15px rgba(23, 101, 199, 0.25);
    border-radius: 16px 16px 0 0;
    background-color: #ffffff;
  }

  .search-footer {
    margin-top: auto;
  }
}
</style>
